(function (appComponents) {

	appComponents.controllers.mvmOverview = function (Components) {
		var mvmOverview = {};

		mvmOverview.name = "mvmOverview";


		Components.getControllerPrototype().extend(mvmOverview);

		mvmOverview.bindings = function () {

		};

		mvmOverview.handlers = {

		};

		mvmOverview.init = function () {

			mvmOverview._renderPageTemplate();

			mvmOverview._applyScript.base.owl();

			mvmOverview._events.dispatchEvent("controllerInitialized");

			mvmOverview._scrollToTop();

		};

		return mvmOverview;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});